import script from "./PositionWarningPop.vue?vue&type=script&setup=true&lang=js"
export * from "./PositionWarningPop.vue?vue&type=script&setup=true&lang=js"

import "./PositionWarningPop.vue?vue&type=style&index=0&id=bb401fc4&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb401fc4"]])

export default __exports__